import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

const inp = "w-full h-11 bg-muted/60 border px-3 text-sm outline-none focus:border-primary";
const Shell = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center p-6">
    <div className="w-full max-w-sm ax-fade"><div className="font-display font-bold text-xl mb-10">AXIOM<span className="text-primary">/</span>ONE</div>{children}</div>
  </div>
);

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    api.post("/auth/forgot-password", { email }).then(() => setSent(true)).catch((ex) => toast.error(errMsg(ex)));
  };
  return (
    <Shell>
      <h2 className="text-2xl font-semibold">Forgot password</h2>
      {sent ? <p data-testid="forgot-sent" className="text-sm text-muted-foreground mt-3">If this email is registered, a reset link is on its way. It works once and expires in 1 hour. Check your inbox and spam folder.</p> : (
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input data-testid="forgot-email" type="email" required placeholder="Your work email" value={email} onChange={(e) => setEmail(e.target.value)} className={inp} />
          <button data-testid="forgot-submit" className="w-full h-11 bg-primary text-primary-foreground text-sm">Email me a reset link</button>
        </form>)}
      <Link to="/login" className="block mt-6 text-sm text-muted-foreground hover:text-primary" data-testid="back-to-login">← Back to sign in</Link>
    </Shell>
  );
};

export const ResetPassword = () => {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [f, setF] = useState({ p: "", c: "" });
  const submit = (e) => {
    e.preventDefault();
    if (f.p !== f.c) { toast.error("The passwords don't match"); return; }
    if (f.p.length < 10 || !/[A-Za-z]/.test(f.p) || !/\d/.test(f.p)) { toast.error("Use at least 10 characters with letters and numbers"); return; }
    api.post("/auth/reset-password", { token: sp.get("token") || "", new_password: f.p })
      .then(() => { toast.success("Password reset. Sign in with your new password."); nav("/login"); }).catch((ex) => toast.error(errMsg(ex)));
  };
  if (!sp.get("token")) return <Shell><h2 className="text-2xl font-semibold">Invalid reset link</h2><p data-testid="reset-invalid" className="text-sm text-muted-foreground mt-2">This link is missing its token. <Link to="/forgot-password" className="text-primary">Request a new one</Link>.</p></Shell>;
  return (
    <Shell>
      <h2 className="text-2xl font-semibold">Choose a new password</h2>
      <p className="text-sm text-muted-foreground mt-2">At least 10 characters, with letters and numbers.</p>
      <form onSubmit={submit} className="mt-6 space-y-3">
        <input data-testid="reset-new" type="password" required placeholder="New password" value={f.p} onChange={(e) => setF({ ...f, p: e.target.value })} className={inp} />
        <input data-testid="reset-confirm" type="password" required placeholder="Confirm new password" value={f.c} onChange={(e) => setF({ ...f, c: e.target.value })} className={inp} />
        <button data-testid="reset-submit" className="w-full h-11 bg-primary text-primary-foreground text-sm">Reset password</button>
      </form>
    </Shell>
  );
};
